<template>
    <div class="sidebar__section sidebar__section--medium-vertical-padding sidebar__section--border-bottom">
        <div class="h4">Persönliche Notiz</div>
        <div class="copy-light">{{ text }}</div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default:''
        }
    }
}
</script>